"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultApi = exports.DefaultApiApiKeys = void 0;
var request_1 = __importDefault(require("request"));
var models_1 = require("../model/models");
var apis_1 = require("./apis");
var defaultBasePath = 'https://fetcher-ho4joes5va-uw.a.run.app';
var DefaultApiApiKeys;
(function (DefaultApiApiKeys) {})(DefaultApiApiKeys = exports.DefaultApiApiKeys || (exports.DefaultApiApiKeys = {}));
var DefaultApi = function () {
  function DefaultApi(basePathOrUsername, password, basePath) {
    this._basePath = defaultBasePath;
    this._defaultHeaders = {};
    this._useQuerystring = false;
    this.authentications = {
      'default': new models_1.VoidAuth()
    };
    this.interceptors = [];
    if (password) {
      if (basePath) {
        this.basePath = basePath;
      }
    } else {
      if (basePathOrUsername) {
        this.basePath = basePathOrUsername;
      }
    }
  }
  Object.defineProperty(DefaultApi.prototype, "useQuerystring", {
    set: function set(value) {
      this._useQuerystring = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultApi.prototype, "basePath", {
    get: function get() {
      return this._basePath;
    },
    set: function set(basePath) {
      this._basePath = basePath;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DefaultApi.prototype, "defaultHeaders", {
    get: function get() {
      return this._defaultHeaders;
    },
    set: function set(defaultHeaders) {
      this._defaultHeaders = defaultHeaders;
    },
    enumerable: false,
    configurable: true
  });
  DefaultApi.prototype.setDefaultAuthentication = function (auth) {
    this.authentications.default = auth;
  };
  DefaultApi.prototype.setApiKey = function (key, value) {
    this.authentications[DefaultApiApiKeys[key]].apiKey = value;
  };
  DefaultApi.prototype.addInterceptor = function (interceptor) {
    this.interceptors.push(interceptor);
  };
  DefaultApi.prototype.getFeed = function (twitterID, instagramID, bloggerID, soundcloudID, swarmID, deviantartID, options) {
    if (options === void 0) {
      options = {
        headers: {}
      };
    }
    return __awaiter(this, void 0, void 0, function () {
      var localVarPath, localVarQueryParameters, localVarHeaderParams, produces, localVarFormParams, localVarUseFormData, localVarRequestOptions, authenticationPromise, interceptorPromise, _loop_1, _i, _a, interceptor;
      var _this = this;
      return __generator(this, function (_b) {
        localVarPath = this.basePath + '/feed';
        localVarQueryParameters = {};
        localVarHeaderParams = Object.assign({}, this._defaultHeaders);
        produces = ['application/json'];
        if (produces.indexOf('application/json') >= 0) {
          localVarHeaderParams.Accept = 'application/json';
        } else {
          localVarHeaderParams.Accept = produces.join(',');
        }
        localVarFormParams = {};
        if (twitterID !== undefined) {
          localVarQueryParameters['twitterID'] = models_1.ObjectSerializer.serialize(twitterID, "number");
        }
        if (instagramID !== undefined) {
          localVarQueryParameters['instagramID'] = models_1.ObjectSerializer.serialize(instagramID, "number");
        }
        if (bloggerID !== undefined) {
          localVarQueryParameters['bloggerID'] = models_1.ObjectSerializer.serialize(bloggerID, "string");
        }
        if (soundcloudID !== undefined) {
          localVarQueryParameters['soundcloudID'] = models_1.ObjectSerializer.serialize(soundcloudID, "string");
        }
        if (swarmID !== undefined) {
          localVarQueryParameters['swarmID'] = models_1.ObjectSerializer.serialize(swarmID, "string");
        }
        if (deviantartID !== undefined) {
          localVarQueryParameters['deviantartID'] = models_1.ObjectSerializer.serialize(deviantartID, "string");
        }
        Object.assign(localVarHeaderParams, options.headers);
        localVarUseFormData = false;
        localVarRequestOptions = {
          method: 'GET',
          qs: localVarQueryParameters,
          headers: localVarHeaderParams,
          uri: localVarPath,
          useQuerystring: this._useQuerystring,
          json: true
        };
        authenticationPromise = Promise.resolve();
        authenticationPromise = authenticationPromise.then(function () {
          return _this.authentications.default.applyToRequest(localVarRequestOptions);
        });
        interceptorPromise = authenticationPromise;
        _loop_1 = function _loop_1(interceptor) {
          interceptorPromise = interceptorPromise.then(function () {
            return interceptor(localVarRequestOptions);
          });
        };
        for (_i = 0, _a = this.interceptors; _i < _a.length; _i++) {
          interceptor = _a[_i];
          _loop_1(interceptor);
        }
        return [2, interceptorPromise.then(function () {
          if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
              localVarRequestOptions.formData = localVarFormParams;
            } else {
              localVarRequestOptions.form = localVarFormParams;
            }
          }
          return new Promise(function (resolve, reject) {
            (0, request_1.default)(localVarRequestOptions, function (error, response, body) {
              if (error) {
                reject(error);
              } else {
                if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                  body = models_1.ObjectSerializer.deserialize(body, "FeedItems");
                  resolve({
                    response: response,
                    body: body
                  });
                } else {
                  reject(new apis_1.HttpError(response, body, response.statusCode));
                }
              }
            });
          });
        })];
      });
    });
  };
  DefaultApi.prototype.proxy = function (url, options) {
    if (options === void 0) {
      options = {
        headers: {}
      };
    }
    return __awaiter(this, void 0, void 0, function () {
      var localVarPath, localVarQueryParameters, localVarHeaderParams, localVarFormParams, localVarUseFormData, localVarRequestOptions, authenticationPromise, interceptorPromise, _loop_2, _i, _a, interceptor;
      var _this = this;
      return __generator(this, function (_b) {
        localVarPath = this.basePath + '/proxy';
        localVarQueryParameters = {};
        localVarHeaderParams = Object.assign({}, this._defaultHeaders);
        localVarFormParams = {};
        if (url !== undefined) {
          localVarQueryParameters['url'] = models_1.ObjectSerializer.serialize(url, "string");
        }
        Object.assign(localVarHeaderParams, options.headers);
        localVarUseFormData = false;
        localVarRequestOptions = {
          method: 'GET',
          qs: localVarQueryParameters,
          headers: localVarHeaderParams,
          uri: localVarPath,
          useQuerystring: this._useQuerystring,
          json: true
        };
        authenticationPromise = Promise.resolve();
        authenticationPromise = authenticationPromise.then(function () {
          return _this.authentications.default.applyToRequest(localVarRequestOptions);
        });
        interceptorPromise = authenticationPromise;
        _loop_2 = function _loop_2(interceptor) {
          interceptorPromise = interceptorPromise.then(function () {
            return interceptor(localVarRequestOptions);
          });
        };
        for (_i = 0, _a = this.interceptors; _i < _a.length; _i++) {
          interceptor = _a[_i];
          _loop_2(interceptor);
        }
        return [2, interceptorPromise.then(function () {
          if (Object.keys(localVarFormParams).length) {
            if (localVarUseFormData) {
              localVarRequestOptions.formData = localVarFormParams;
            } else {
              localVarRequestOptions.form = localVarFormParams;
            }
          }
          return new Promise(function (resolve, reject) {
            (0, request_1.default)(localVarRequestOptions, function (error, response, body) {
              if (error) {
                reject(error);
              } else {
                if (response.statusCode && response.statusCode >= 200 && response.statusCode <= 299) {
                  resolve({
                    response: response,
                    body: body
                  });
                } else {
                  reject(new apis_1.HttpError(response, body, response.statusCode));
                }
              }
            });
          });
        })];
      });
    });
  };
  return DefaultApi;
}();
exports.DefaultApi = DefaultApi;